import JSZip from 'jszip';
import { saveAs } from 'file-saver';

async function writeFilesToArchive(files, stationNames) {
    if (Object.keys(files).length === 0) {
        console.log("No files to write.");
        return;
    }

    const zip = new JSZip();

    // Create a folder for each station in the zip based on stationNames
    const stationFolders = {};

    // Loop through the provided station names to create folders in the zip
    stationNames.forEach(stationName => {
        stationFolders[stationName] = zip.folder(stationName); // Create the station folder
    });

    // Loop through the files and add them to the corresponding station folder
    Object.entries(files).forEach(([fileName, fileBlob]) => {
        // Sanitize the file name by replacing / with _
        const sanitizedFileName = fileName.replace(/\//g, '_'); // Replace / with _

        // Loop through stationNames and check if the file name contains the station name
        const matchedStation = stationNames.find(station => fileName.includes(station));

        if (matchedStation) {
            // Add the sanitized file to the matched station folder
            stationFolders[matchedStation].file(sanitizedFileName, fileBlob); // This will NOT create subfolders
            console.log(`Added ${sanitizedFileName} to ${matchedStation} folder.`);
        } else {
            console.log(`No matching station folder for file ${fileName}`);
        }
    });

    // Generate the zip file
    const zipContent = await zip.generateAsync({ type: 'blob' });

    // Trigger a download of the zip file using FileSaver.js
    const folderName = getCurrentDate();
    const zipFileName = `FMS-FMOSticker_${folderName}.zip`;

    saveAs(zipContent, zipFileName);
    console.log("Output was written to station_pdfs.zip");
}

const getCurrentDate = () => {
    // Generate the current date in ddmmyyyy format
    const currentDate = new Date();
    const dd = String(currentDate.getDate()).padStart(2, '0');  // Day
    const mm = String(currentDate.getMonth() + 1).padStart(2, '0'); // Month
    const yyyy = currentDate.getFullYear(); // Year
    const formattedDate = `${dd}${mm}${yyyy}`; // Format as ddmmyyyy
    return formattedDate;
}

export default writeFilesToArchive;
